import {
  Component,
  EventEmitter,
  Inject,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core'
import { completedGamePollTimeoutToken } from '../../providers/completed-game-poll-timeout.provider'

@Component({
  selector: 'sans-completed-game',
  standalone: true,
  imports: [],
  templateUrl: './completed-game.component.html',
  styleUrl: './completed-game.component.scss',
})
export class CompletedGameComponent implements OnInit, OnDestroy {
  private pollingIntervalId = setTimeout(() => {})
  @Output() public timerExpired = new EventEmitter<void>()

  completedGameLabel = $localize`:Completed game component|Completed game label:Game completed. Starting next...`

  public constructor(
    @Inject(completedGamePollTimeoutToken)
    private readonly completedGamePollTimeout: number,
  ) {}

  public ngOnInit(): void {
    this.pollingIntervalId = setInterval(() => {
      this.timerExpired.emit()
    }, this.completedGamePollTimeout)
  }

  public ngOnDestroy(): void {
    clearInterval(this.pollingIntervalId)
  }
}
